export const NotificationActionConst = {
  FETCH_NOTIFICATIONS_REQUEST: "FETCH_NOTIFICATIONS_REQUEST",
  FETCH_NOTIFICATIONS_SUCCESS: "FETCH_NOTIFICATIONS_SUCCESS",
  FETCH_NOTIFICATIONS_FAIL: "FETCH_NOTIFICATIONS_FAIL",
  FETCH_UNREAD_COUNT_SUCCESS: "FETCH_UNREAD_COUNT_SUCCESS",
  MARK_READ_SUCCESS: "MARK_READ_SUCCESS",
  FCM_TOKEN_REGISTERED: "FCM_TOKEN_REGISTERED",
  ADD_FOREGROUND_NOTIFICATION: "ADD_FOREGROUND_NOTIFICATION",
};
